(function () {
  // Wait for the page to be fully ready
  document.addEventListener('DOMContentLoaded', function () {
    initVariantImageFilter();
  });

  function initVariantImageFilter() {
    var productEl = document.querySelector('[data-product-id]');
    if (!productEl) return;

    var productId = productEl.getAttribute('data-product-id');

    // Load product JSON
    var productJsonEl = document.getElementById('ProductJson-product-template');
    if (!productJsonEl) return;

    var product;
    try {
      product = JSON.parse(productJsonEl.textContent);
    } catch (e) {
      console.error('[VariantFilter] Could not parse product JSON', e);
      return;
    }

    // If product has only one variant (no variant options), show all images and stop
    if (product.variants.length === 1) {
      console.log('[VariantFilter] Single variant product — skipping image filter.');
      return;
    }

    // Run filter on initial page load for the pre-selected variant
    var initialVariantId = getSelectedVariantId();
    if (initialVariantId) {
      var initialVariant = findVariant(product, initialVariantId);
      if (initialVariant) filterImages(initialVariant.sku);
    }

    // Listen for Dawn's native variant change event
    // Dawn dispatches a custom 'variant:change' event on the product form
    document.addEventListener('variant:change', function (e) {
      var variant = e.detail && e.detail.variant;
      if (!variant) return;
      filterImages(variant.sku);
    });

    // Fallback: also watch the hidden variant input directly
    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!input) return;

      // Dropdown or hidden input named "id" inside a product form
      if (input.name === 'id' || input.getAttribute('data-productid')) {
        var variantId = input.value;
        var variant = findVariant(product, variantId);
        if (variant) filterImages(variant.sku);
      }
    });
  }

  function getSelectedVariantId() {
    // Dawn puts the selected variant ID in a hidden input or a select[name="id"]
    var input = document.querySelector(
      'form[action*="/cart/add"] input[name="id"], ' +
      'form[action*="/cart/add"] select[name="id"]'
    );
    return input ? input.value : null;
  }

  function findVariant(product, variantId) {
    return product.variants.find(function (v) {
      return String(v.id) === String(variantId);
    });
  }

  function imageMatchesSku(alt, sku) {
    if (alt === '') return true;          // blank = shared, always show
    return alt.indexOf(sku) !== -1;       // contains the SKU anywhere in alt text
  }

  function filterImages(sku) {
    if (!sku) return;

    console.log('[VariantFilter] Filtering for SKU:', sku);

    // Main gallery items
    var mediaItems = document.querySelectorAll(
      'ul.product__media-list > li, ' +
      '.product__media-wrapper li[data-index], ' +
      'li.product__media-item'
    );

    mediaItems.forEach(function (item) {
      var img = item.querySelector('img');
      if (!img) return;

      var alt = (img.getAttribute('alt') || '').trim();
      console.log('[VariantFilter] Image alt:', alt, '| Match:', imageMatchesSku(alt, sku));

      if (imageMatchesSku(alt, sku)) {
        item.style.removeProperty('display');
        item.classList.remove('hidden');
      } else {
        item.style.display = 'none';
        item.classList.add('hidden');
      }
    });

    // Thumbnails (for thumbnail / thumbnail_slider layout)
    var thumbItems = document.querySelectorAll(
      '.product__media-thumbs li, ' +
      '.thumbnail-list li'
    );

    thumbItems.forEach(function (item) {
      var img = item.querySelector('img');
      if (!img) return;

      var alt = (img.getAttribute('alt') || '').trim();

      if (imageMatchesSku(alt, sku)) {
        item.style.removeProperty('display');
        item.classList.remove('hidden');
      } else {
        item.style.display = 'none';
        item.classList.add('hidden');
      }
    });
  }
})();